// mindzera-frontend/src/main.jsx

window.addEventListener('error', e => {
  const msg = e.error?.stack || e.message || 'Unknown error';
  document.body.innerHTML =
    '<pre style="white-space:pre-wrap;padding:24px;color:red;background:#fff">' +
    msg +
    '</pre>';
});

window.addEventListener('unhandledrejection', e => {
  const msg = e.reason?.stack || e.reason || 'Unhandled promise rejection';
  document.body.innerHTML =
    '<pre style="white-space:pre-wrap;padding:24px;color:red;background:#fff">' +
    msg +
    '</pre>';
});

import './mapGuard.js';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import ErrorBoundary from './ErrorBoundary.jsx';
import { AuthProvider } from './AuthContext.jsx';  // ✅ added
import './index.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <AuthProvider>                                 {/* ✅ wrap added */}
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </AuthProvider>
  </React.StrictMode>
);
